//  Componente di visualizzazione messaggio in seguito a iscrizione o disiscrizione
import parse from 'html-react-parser';
import { PropTypes } from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import queryString from 'query-string';

import htmlParserTransform from '../../helpers/htmlParserTransform';

import Redirect from '../common/Redirect';
import Notification from '../common/notification/Notification';
import Personalization from '../common/personalization/Personalization';
import LoadingSpinner from '../common/spinner/LoadingSpinner';

import PublicCustomAPI from '../../api/publiccustom/PublicCustomAPI';

import MapperService from '../../services/MapperService';

import deepGetSet from '../../api/deepGetSet';
import FrontendException from '../../models/FrontendException';

import withResizeObserver from '../../hoc/withResizeObserver';

class UnsubscriptionMsg extends React.Component {
  constructor() {
    super();
    //
    this.mounted = false;
    this.notificationRef = React.createRef();
    //
    this.actionSettings = {};
    this.textSettings = {};
    //
    this.msgSettings = {
      Content: '',
      RedirectURL: ''
    };
    this.listGUID = '';
    this.clientIP = '';
    this.emailForPreview = 'test@test.com';
    //
    this.state = {
      loading: false,
      showMainContent: false
    };
  }

  componentDidMount() {
    this.mounted = true;

    if (!this.isUserParamsValid()) {
      //  do not use setState directly in componentDidMount
      this.handleError("Load.Msg.ErrorUserParams");
    } else {
      //
      const params = this.props.match.params;
      const actionCode = this.getActionCode(params.idMsg);
      const qsValues = queryString.parse(this.props.location.search);
      //
      Promise.all([
        this.getPublicCustomAction(params.idList, actionCode, qsValues.email, this.isTrue(params.preview)),
        this.getPublicCustomText(params.idList, actionCode),
        this.getListGUID(params.idList),
        this.getClientIP()
      ]).then(() => {
        if (deepGetSet(this.textSettings, 'Text')) {
          this.msgSettings.Content = this.textSettings.Text;
        } else {
          const msgLabel = MapperService.getPostEventDefaultMessage(actionCode);
          this.msgSettings.Content = this.props.intl.formatMessage({
            id: msgLabel,
            defaultMessage: msgLabel
          });
        }
        //
        if (this.isTrue(params.preview)) {
          this.msgSettings.RedirectURL = '';
          //
          this.msgSettings.Content = this.replacePlaceholders(this.msgSettings.Content, {
            email: this.emailForPreview,
            IPaddress: this.clientIP
          }, false);
        } else {
          if (this.actionSettings.IdLandingPage) {
            this.msgSettings.RedirectURL = '/frontend/LandingPage.aspx?idList=' +
              encodeURIComponent(params.idList) + '&idLP=' + encodeURIComponent(this.actionSettings.IdLandingPage) +
              '&guid=' + encodeURIComponent(this.listGUID);
            this.msgSettings.Content = undefined;
          } else if (this.actionSettings.CustomUrl) {
            this.msgSettings.RedirectURL = this.actionSettings.CustomUrl;
            //
            this.msgSettings.RedirectURL = this.replacePlaceholders(this.msgSettings.RedirectURL, {
              email: qsValues.email,
              IPaddress: this.clientIP
            }, true);
            this.msgSettings.Content = undefined;
          } else {
            this.msgSettings.Content = this.replacePlaceholders(this.msgSettings.Content, {
              email: qsValues.email,
              IPaddress: this.clientIP
            }, false);
          }
        }
        //
        if (this.mounted) {
          this.setState({
            showMainContent: true
          });
        }
      }).catch((error) => {
        this.handleError(error, "default", true);
      })
        .finally(this.stopLoader);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  isTrue(paramValue) {
    return ((paramValue == "true") || (paramValue == "1") || (paramValue == "on"));
  }

  isString(param) {
    return (typeof param === "string") || (param instanceof String);
  }

  /**
   * Verifica parametri idList, idMsg, email
   * se vuoti/nulli ritorna false
   */
  isUserParamsValid() {
    const params = this.props.match.params;
    //
    return Boolean(params.idList && params.idMsg);
  }

  handleError = (error, source = "default", fatal = false) => {
    let errorLabel = "Load.Common.Error";
    if (error instanceof FrontendException) {
      errorLabel = error.label;
    } else if (this.isString(error)) {
      errorLabel = error;
    }
    //
    this.notificationRef.current.addError(this.props.intl.formatMessage({ id: errorLabel, defaultMessage: errorLabel }), source, false, !fatal);
  }

  getPublicCustomAction(idList, actionCode, email, preview) {
    return preview ? PublicCustomAPI.getAction(idList, actionCode).then((actionSettings) => {
      this.actionSettings = actionSettings;
    })
      : PublicCustomAPI.getActionForRecipient(idList, actionCode, email, preview).then((actionSettings) => {
        this.actionSettings = actionSettings;
      })
      ;
  }

  getPublicCustomText(idList, actionCode) {
    return PublicCustomAPI.getText(idList, actionCode).then((textSettings) => {
      this.textSettings = textSettings;
    });
  }

  getListGUID(idList) {
    return PublicCustomAPI.getListGUID(idList).then((listGUID) => {
      this.listGUID = listGUID;
    });
  }

  getClientIP() {
    return PublicCustomAPI.getClientIP().then((clientIP) => {
      this.clientIP = clientIP;
    });
  }

  replacePlaceholders(content, map, uriEncode) {
    Object.keys(map).forEach((key) => {
      if (uriEncode) {
        content = content.replaceAll('[' + key + ']', encodeURIComponent(map[key]));
      } else {
        content = content.replaceAll('[' + key + ']', map[key]);
      }
    });
    return content;
  }

  getActionCode(idMsg) {
    let result = "";
    switch (parseInt(idMsg, 10)) {
      case 11:
        result = "PostUnsubscription_RecipientAlreadyUnsubscribed";
        break;
      case 1:
        result = "PostUnsubscription_GenericError";
        break;
      case 7:
        result = "PostUnsubscription_UnsubscriptionCompleted";
        break;
      case 20:
        result = "PostUnsubscription_RecipientDoesNotExist";
        break;
      case 0:
        result = "PostUnsubscription_UpdateOK";
        break;
    }
    return result;
  }

  startLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: true
      });
    }
  }

  stopLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    return (
      <div>
        <Notification ref={this.notificationRef} />
        {this.state.loading && <LoadingSpinner />}

        {this.state.showMainContent &&
          <React.Fragment>
            {this.msgSettings.RedirectURL &&
              <Redirect to={this.msgSettings.RedirectURL} />
            }

            {this.msgSettings.Content &&
              <div className="frontend-wrapper">
                <Personalization idList={this.props.match.params.idList} showLogo applyCustomCSS />
                <div className="frontend-box frontend-row">
                  <div className="frontend-row frontend-text-casistica">{parse(this.msgSettings.Content, { replace: htmlParserTransform })}</div>
                </div>
              </div>
            }
          </React.Fragment>
        }
      </div>
    );
  }
}

UnsubscriptionMsg.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      preview: PropTypes.string.isRequired,
      idList: PropTypes.string.isRequired,
      idMsg: PropTypes.string.isRequired,
      email: PropTypes.string
    })
  }),
  location: PropTypes.object,

};

export default withResizeObserver(injectIntl(UnsubscriptionMsg), 'UnsubscriptionMsg');